document.addEventListener("DOMContentLoaded", () => {
  let outer = document.querySelector('.jackpot-wrapper');
  let backToLeft = outer?.querySelector(".back-to-left")
  let inner = outer?.querySelector(".track");
  let mbShowMore = document.querySelector('.mb-showmore');
  let outClientWidth = outer?.clientWidth;
  let innerScrollWidth = inner?.scrollWidth;
  let isOverflowing = innerScrollWidth > outClientWidth;
  let dataLevel = parseInt(mbShowMore?.getAttribute('data-level'), 10);
  let dataTotalSize = parseInt(mbShowMore?.getAttribute('data-totalsize'), 10);
  let jackpotContainer_Element = document.querySelector('.jackpot-container');

  // Activity Ending
  let winnerScroll = document.querySelector('.winner-list ul');
  let lis = winnerScroll.querySelectorAll('li');
  let fragment = document.createDocumentFragment();
  lis.forEach(li => {
    let clone = li.cloneNode(true);
    fragment.appendChild(clone);
  });
  winnerScroll.appendChild(fragment);

  if(window.innerWidth > 1200 && isOverflowing) {
    let scrollAmount = innerScrollWidth - outClientWidth;
    // 鼠标移入移出事件
    outer?.addEventListener("mouseenter", () => {
      inner.style.transform = `translateX(-${scrollAmount}px)`;
      backToLeft.classList.remove("hidden");
    });
    outer?.addEventListener("mouseleave", () => {
      inner.style.transform = "translateX(0)";
      backToLeft.classList.add("hidden");
    });
    backToLeft.addEventListener("click", () => {
      inner.style.transform = "translateX(0)";
      backToLeft.classList.add("hidden");
    });
    backToLeft.addEventListener('keydown', function(e) {
      if(e.key == 'Enter' || e.key == ' ') {
        e.preventDefault();
        e.stopPropagation();
        $(this).click();
      }
    });

    // 监听器
    // let timer = null;
    // const observer = new IntersectionObserver((entries) => {
    //   const entry = entries[0];
    //   if (entry.isIntersecting) {
    //     // 进入可视区域
    //     timer = setTimeout(() => {
    //       inner.style.transform = `translateX(-${scrollAmount}px)`;
    //       backToLeft.classList.remove("hidden");
    //     }, 500);
    //   } else {
    //     inner.style.transform = 'translateX(0)';
    //     backToLeft.classList.add("hidden");
    //     clearTimeout(timer);
    //   }
    // }, {
    //   threshold: 0.5
    // });
    // observer.observe(inner);
  }

  else if (window.innerWidth < 1200 && mbShowMore) {
    if (dataLevel < dataTotalSize) {
      mbShowMore.innerHTML = 'Show More<span>+</span>';
    } else {
      mbShowMore.innerHTML = 'Show Less<span>-</span>';
    }
    mbShowMore.addEventListener('click', function() {
      jackpotContainer_Element.classList.toggle('active');
      if (jackpotContainer_Element.classList.contains('active')) {
        mbShowMore.innerHTML = 'Show More<span>+</span>'; 
      } else {
        mbShowMore.innerHTML = 'Show Less<span>-</span>';
      }
    });
  }
});